
















































import { Component, Prop, Vue } from 'vue-property-decorator';
import MainButton from '@/main-components/common/MainButton.vue';
import Modal from '@/main-components/common/modal/Modal.vue';
import Input from '../common/Input.vue';
import {
  GenerateQuestion,
  QuestionGeneratedType,
} from '@/resource/question-generated/question-generated.model';
import { axiosAi } from '@/utils/axios-generate-question';
import { PaperGeneratedItem } from '@/resource/paper-generated-item/paper-generated-item.model';
import GeneratedQuestionContainer from '@/main-components/question-generated/GeneratedQuestionContainer.vue';
import { axios } from '@/utils/axios';
import { isHasChartJs } from '@/utils/add-script';

async function generateQuestion(
  questionGeneratedId: number,
  topic: string | null,
): Promise<GenerateQuestion> {
  try {
    const { data } = await axiosAi.post('/question-generated/generate', {
      questionGeneratedId,
      topic,
    });
    return data;
  } catch (error) {
    // NOTE: dummy generated qustion
    return {
      parentId: 99999,
      subjectUuid: '',
      form: 0,
      chapterId: 99999,
      type: QuestionGeneratedType.Objective,
      html:
        '<div>ERROR: Please try again<div><div class="answer_container">No answer</div>',
      openAiResponse: {},
      openAiConfig: {},
    };
  }
}

function DataURIToBlob(dataURI: string) {
  const splitDataURI = dataURI.split(',');
  const byteString =
    splitDataURI[0].indexOf('base64') >= 0
      ? atob(splitDataURI[1])
      : decodeURI(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);

  return new Blob([ia], { type: mimeString });
}

async function uploadImage(imgBase64: string) {
  const file = DataURIToBlob(imgBase64);
  const formData = new FormData();
  formData.append('file', file, 'image.jpg');

  const headers = {
    'Content-Type': 'multipart/form-data',
  };

  try {
    const { data } = await axios.post('file_upload', formData, {
      headers,
    });

    return data;
  } catch (error) {
    console.log('data:', error);
    return null;
  }
}

@Component({
  components: {
    MainButton,
    Modal,
    Input,
    GeneratedQuestionContainer,
  },
})
export default class ModalGenerateQuestion extends Vue {
  @Prop({ required: true })
  paperGeneratedItem: PaperGeneratedItem;

  @Prop({ required: true })
  updateNewQuestionGenerated: (params: {
    paperGeneratedItemId: number;
    newQuestionGenerated: GenerateQuestion;
  }) => void;

  isLoading = false;
  openModal: any = null;
  closeModal: any = null;
  submitInputTopic: any = null;
  newQuestionGenerates: GenerateQuestion[] = [];

  mounted() {
    this.$emit('openModalGenerateQuestionAdd', () => {
      this.newQuestionGenerates = [];
      this.openModal && this.openModal();
    });
  }

  openModalAdd(openModal: any) {
    this.openModal = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModal = closeModal;
  }

  addSubmitInputTopic(submitInput: any) {
    this.submitInputTopic = submitInput;
  }

  async generateClick() {
    this.isLoading = true;
    this.newQuestionGenerates = [];

    const topic =
      this.submitInputTopic && (await this.submitInputTopic()).value;

    const questionGenetedId = this.paperGeneratedItem?.questionGenerated.id;

    if (questionGenetedId) {
      const newQuestionGenerate1 = await generateQuestion(
        questionGenetedId,
        topic,
      );

      this.newQuestionGenerates = [newQuestionGenerate1];

      await this.timeout(5000);

      const newQuestionGenerate2 = await generateQuestion(
        questionGenetedId,
        topic,
      );

      this.newQuestionGenerates.push(newQuestionGenerate2);
    }

    this.isLoading = false;
  }

  async timeout(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async useClick(id: number) {
    const chooseNewQuestionGenerate = this.newQuestionGenerates[id];

    const newSavedImageHtml = await this.saveGraphImageInHtml(
      chooseNewQuestionGenerate.html,
    );

    if (newSavedImageHtml) {
      chooseNewQuestionGenerate.html = newSavedImageHtml;
    }

    this.updateNewQuestionGenerated({
      paperGeneratedItemId: this.paperGeneratedItem.id,
      newQuestionGenerated: chooseNewQuestionGenerate,
    });

    this.closeModal && this.closeModal();
  }

  async saveGraphImageInHtml(html: string) {
    if (!isHasChartJs(html)) return null;

    const question = `${html}`;

    // -------------------------------------

    const replaceSrc = async (imageTag: string) => {
      const startSrc = imageTag.indexOf('src="');
      const endSrc = imageTag.indexOf('"', startSrc + 'src="'.length);

      const startId = imageTag.indexOf('id="');
      const endId = imageTag.indexOf('"', startId + 'id="'.length);

      const imageId = imageTag.slice(startId, endId).replace('id="', '');
      const imageSrc = imageTag.slice(startSrc, endSrc).replace('src="', '');

      let newSrcImageUrl = imageSrc;

      if (imageId) {
        const imageElement = document.getElementById(imageId);
        if (imageElement) {
          const based64Image = (imageElement as any).src as string;

          // NOTE: to only upload src content that is based64 (Most image link has mysoalan in it)
          if (!based64Image.includes('mysoalan')) {
            const uploadedImage = await uploadImage(based64Image);
            if (uploadedImage && uploadedImage.url) {
              newSrcImageUrl = uploadedImage.url;
            }
          }
        }
      }

      const newImageTag =
        imageTag.substring(0, startSrc + 'src="'.length) +
        newSrcImageUrl +
        imageTag.substring(endSrc, imageTag.length);

      return newImageTag;
    };

    // -------------------------------------

    const replaceImagesInHTML = (
      originalHTML: string,
      imageTagsArray: {
        startIndex: number;
        endIndex: number;
        imageTag: string;
      }[],
    ) => {
      // Sort the imageTagsArray by startIndex in descending order
      imageTagsArray.sort((a, b) => b.startIndex - a.startIndex);

      let modifiedHTML = originalHTML;

      for (const imageTagInfo of imageTagsArray) {
        const before = modifiedHTML.slice(0, imageTagInfo.startIndex);
        const after = modifiedHTML.slice(imageTagInfo.endIndex + 1);
        modifiedHTML = before + imageTagInfo.imageTag + '>' + after;
      }

      return modifiedHTML;
    };

    // -------------------------------------

    const images: {
      startIndex: number;
      endIndex: number;
      imageTag: string;
    }[] = [];

    let startIndex = -1;
    while ((startIndex = question.indexOf('<img', startIndex + 1)) != -1) {
      const endIndex = question.indexOf('/>', startIndex) + '/>'.length - 1;
      const imageTag = question.slice(startIndex, endIndex);

      const newImageTag = await replaceSrc(imageTag);

      images.push({
        startIndex,
        endIndex,
        imageTag: newImageTag ? newImageTag : imageTag,
      });
    }

    const modifiedHtml = replaceImagesInHTML(question, images);
    return modifiedHtml;
  }
}
